module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div data-region="temperature-alert"></div><div data-region="battery-alert"></div><div data-region="power-alert"></div><fieldset class="button-wrap"><button data-click="homeAlerts-close">'+
((__t=( i18n.tc("ControlHomeAlerts", "Close") ))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
